import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { CreateSquadRequest, UpdateSquadRequest } from "@/types/squad.type"; // Corrigido
import { squadService } from "@/services/api/squad.service";

export function useSquadActions() {
  const queryClient = useQueryClient();

  const invalidateQueriesGlobally = () => {
    queryClient.invalidateQueries({ queryKey: ["squads-list"] });
  };

  const onSuccessAction = (mensagem: string) => {
    invalidateQueriesGlobally();
    toast.success(mensagem);
  };

  const onErrorAction = (error: any, defaultMessage: string) => {
    console.error(defaultMessage, error);
  };

  const createMutation = useMutation({
    mutationFn: (data: CreateSquadRequest) => squadService.createSquad(data),
    onSuccess: () => onSuccessAction("Squad cadastrado com sucesso!"),
    onError: (error) => onErrorAction(error, "Falha ao cadastrar squad."),
  });

  // Corrigido para receber UpdateSquadRequest
  const updateMutation = useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateSquadRequest }) =>
      squadService.updateSquad(id, data),
    onSuccess: () => onSuccessAction("Squad atualizado com sucesso!"),
    onError: (error) => onErrorAction(error, "Falha ao atualizar squad."),
  });

  const inactivateMutation = useMutation({
    mutationFn: (id: number) => squadService.inactivateSquad(id),
    onSuccess: () => onSuccessAction("Squad inativado com sucesso!"),
    onError: (error) => onErrorAction(error, "Falha ao inativar squad."),
  });

  const reactivateMutation = useMutation({
    mutationFn: (id: number) => squadService.reactivateSquad(id),
    onSuccess: () => onSuccessAction("Squad reativado com sucesso!"),
    onError: (error) => onErrorAction(error, "Falha ao reativar squad."),
  });

  return {
    isCreating: createMutation.isPending,
    isUpdating: updateMutation.isPending,
    isTogglingStatus: inactivateMutation.isPending || reactivateMutation.isPending,

    // Corrigidos os nomes dos exports
    createSquad: createMutation.mutateAsync,
    updateSquad: updateMutation.mutateAsync,
    inactivateSquad: inactivateMutation.mutateAsync,
    reactivateSquad: reactivateMutation.mutateAsync,
  };
}
